import SomethingWentWrong from 'pages/somethin-went-wrong';
import React from 'react';
import { useLocation } from 'react-router';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
  errorInfo?: React.ErrorInfo;
}

class ErrorBoundaryClass extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    this.setState({ error, errorInfo });
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <SomethingWentWrong error={this.state.error} errorInfo={this.state.errorInfo} />;
    }

    return this.props.children;
  }
}

const ErrorBoundary: React.FC<Props> = (props) => {
  const location = useLocation();
  const key = location.pathname;

  return <ErrorBoundaryClass key={key} {...props} />;
};

export default ErrorBoundary;
